import { Fragment } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";

export const ListContact = ({ data = [] }) => {
  if (!data.length) {
    return (
      <Row className="pa6" center="xs">
        <Typography variant="body1">Aún no has cargado contactos</Typography>
      </Row>
    );
  }

  return (
    <Row>
      <Col md={12}>
        <List>
          {data.map(({ _id, name, phoneNumber, relation }) => (
            <Fragment key={_id}>
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar alt={name} src="/static/images/avatar/1.jpg" />
                </ListItemAvatar>
                <ListItemText
                  primary={phoneNumber}
                  secondary={
                    <>
                      <Typography
                        component="span"
                        variant="body2"
                        color="textPrimary"
                      >
                        {name}
                      </Typography>
                      {` — ${relation}`}
                    </>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" />
            </Fragment>
          ))}
        </List>
      </Col>
    </Row>
  );
};
